import logoMark from "@/assets/logo-mark.svg";
import { SidebarNavContent } from "@/components/AppSidebar";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

interface MobileNavProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MobileNav({ open, onOpenChange }: MobileNavProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="flex w-72 flex-col gap-0 p-0">
        <SheetHeader className="flex h-16 flex-row items-center gap-3 border-b border-border px-5 py-0 pr-12 space-y-0">
          <img
            src={logoMark}
            alt=""
            aria-hidden="true"
            className="h-9 w-9 shrink-0 drop-shadow-[0_8px_20px_-10px_rgba(37,99,235,0.85)]"
          />
          <SheetTitle className="leading-tight font-display bg-gradient-to-br from-slate-900 to-blue-700 bg-clip-text text-lg font-semibold tracking-tight text-transparent">
            Nuntius
          </SheetTitle>
        </SheetHeader>
        <div className="flex flex-1 flex-col overflow-y-auto">
          <SidebarNavContent onNavigate={() => onOpenChange(false)} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
